import styled from 'styled-components';
import { rgba } from 'polished';
import { COLOR_WHITE, COLOR_GREEN, COLOR_RED, COLOR_ORANGE } from '../../../assets/styles/colors';
import { BP_NETBOOK_MAX, BP_MOBILE_MAX } from '../../../assets/styles/breakpoints';

export default styled.div``;

export const ChartTopSC = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 180px;
`;

export const ChartBottomSC = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-flow: row wrap;
  .legend {
    margin-top: 10px;
    display: flex;
    width: 100%;
    height: 20px;
    border-top: 1px solid ${rgba(COLOR_WHITE, 0.1)};
    div {
      padding-right: 24px;
      span {
        height: 8px;
        width: 8px;
        display: inline-block;
        border-radius: 8px;
        margin-right: 6px;
      }
      &.green {
        span {
          background: ${COLOR_GREEN};
        }
      }
      &.red {
        span {
          background: ${COLOR_RED};
        }
      }
      &.grey {
        span {
          background: #83828f;
        }
      }
    }
  }

  @media (max-width: ${BP_NETBOOK_MAX}px) {
    .legend {
      div {
        padding-right: 15px;
      }
    }
  }
  @media (max-width: ${BP_MOBILE_MAX}px) {
    .legend {
      flex-flow: row wrap;
      border-top: none;
    }
  }
`;

export const ChartWrapSC = styled.div`
  width: 180px;
  height: 210px;
  position: relative;
  margin-top: 35px;
  padding-bottom: 30px;
  @media (max-width: ${BP_MOBILE_MAX}px) {
    width: 150px;
    height: 180px;
  }
`;

export const DataWrapSC = styled.div`
  padding-left: 30px;
  margin-top: 20px;
  width: calc(100% - 180px);
  .row {
    padding-bottom: 16px;
    &.smaller-padding {
      padding-bottom: 8px;
      &:first-child {
        padding-bottom: 4px;
      }
    }
    &:first-child {
      padding-bottom: 12px;
    }
    .col {
      h3,
      h4 {
        margin-bottom: 0;
      }
    }
  }
  @media (max-width: ${BP_MOBILE_MAX}px) {
    width: calc(100% - 150px);
  }
`;

export const BackButtonSC = styled.button`
  height: 20px;
  display: block;
  font-size: 14px;
  font-weight: 600;
  color: ${COLOR_WHITE};
  border: none;
  max-width: 111px;
  width: 100%;
  border-radius: 6px;
  margin: 5px 0 0 0;
  padding: 0;
  background: ${rgba(COLOR_WHITE, 0.2)};

  @media (max-width: ${BP_MOBILE_MAX}px) {
    max-width: 60px;
  }
`;

export const ChartInsideStatsSC = styled.div`
  ${({ selected }) =>
    selected === 'paid'
      ? ` box-shadow: inset 0 0 30px ${rgba('#09BA50', 0.3)};`
      : selected === 'medium-delay'
      ? ` box-shadow: inset 0 0 30px ${rgba('#83828F', 0.3)};`
      : selected === 'high-delay'
      ? ` box-shadow: inset 0 0 30px ${rgba('#F71D1D', 0.3)};`
      : `box-shadow: none`}
  height:   ${({ selected }) => (selected === '' ? '160px' : '166px')};
  width:   ${({ selected }) => (selected === '' ? '160px' : '166px')};
  border-radius:   ${({ selected }) => (selected === '' ? '160px' : '166px')};
  top:   ${({ selected }) => (selected === '' ? '10px' : '7px')};
  z-index: 10;
  position: absolute;
  text-align: center;
  left: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  transform: translate(-50%, 0%);
  left: 50%;

  span{
    position:relative;
    cursor:pointer;
  }

  .tooltip {
    font-size: 14px;
    font-weight: 600;
    border-radius: 16px;
    background-color: #ffffff;
    box-shadow: 0 4px 15px 0 rgba(47, 46, 65, 0.15);
    display: flex;
    justify-content: center;
    align-items: center;
    height: 48px;
    width: 170px;
    padding: 0 25px;
    position: absolute;
    z-index: 99;
    left: 40px;
    top: -8px;
    svg {
      transform: rotateZ(-90deg);
      position: absolute;
      left: -25px;
    }
  }

  .separator {
    height: 1px;
    width: 82px;
    background: ${rgba(COLOR_WHITE, 0.1)};
  }
  .separator-detail {
    height: 1px;
    width: 111px;
    background: ${rgba(COLOR_WHITE, 0.1)};
  }
  .all-stats {
    align-items: center;
    display: flex;
    flex-direction: column;
  }
  @media (max-width: ${BP_MOBILE_MAX}px) {
  height:   ${({ selected }) => (selected === '' ? '130px' : '140px')};
  width:   ${({ selected }) => (selected === '' ? '130px' : '140px')};
  border-radius:   ${({ selected }) => (selected === '' ? '130px' : '140px')};
  top:   ${({ selected }) => (selected === '' ? '10px' : '3px')};

  .separator-detail {
    width: 60px;
  }
  .separator {
    width: 60px;
  }

  }
`;

export const GraphToggleButton = styled.button`
  position: absolute;
  bottom: 0;
  left: 0;

  width: 26px;
  height: 26px;
  border: none;

  color: white;

  color: ${COLOR_ORANGE};
  background: transparent;
  border: 1px solid ${COLOR_ORANGE};
  border-radius: 8px;

  &.active {
    color: ${COLOR_WHITE};
    background: ${COLOR_ORANGE};
  }

  span {
    position: absolute;
    top: 1px;
    left: 6px;
    font-size: 15px;
  }
`;
